/**
 * @generated SignedSource<<722971e267b23a7a11504625d99e8001>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingSlackValidateConnectionFragment$data = {
  readonly content: {
    readonly organization: {
      readonly slack: {
        readonly workspace: {
          readonly name: string | null;
          readonly url: string | null;
        } | null;
      } | null;
    };
  };
  readonly " $fragmentType": "MemberOnboardingSlackValidateConnectionFragment";
};
export type MemberOnboardingSlackValidateConnectionFragment$key = {
  readonly " $data"?: MemberOnboardingSlackValidateConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingSlackValidateConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingSlackValidateConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlackConnection",
              "kind": "LinkedField",
              "name": "slack",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SlackWorkspace",
                  "kind": "LinkedField",
                  "name": "workspace",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "9b42d2b3893f749f8a0957b8eec50ba0";

export default node;
